<app-plan-change-panel
  *ngIf="planChangeTarget as target"
  [subscriptionId]="target.subscriptionId"
  [locationId]="target.locationId"
  [isActive]="true"
  [showBackButton]="false"
  (back)="closePlanChange()"
  (applied)="onPlanChangeApplied($event)"
/>

<div class="family-plan-container" *ngIf="view?.in_family && !planChangeTarget">
  <section class="plan" data-testid="family-plan">
    <header class="plan-header">
      <h3 class="plan-title">Family Plan</h3>
      <p class="plan-summary" [class.at-limit]="atLimit" data-testid="family-plan-summary">
        {{ seats }}
      </p>
    </header>

    <div class="limit-warning" *ngIf="atLimit" role="status">
      <strong>Vehicle limit reached.</strong> Remove a vehicle to add another.
    </div>

    <div class="primary-link" *ngIf="secondary && view?.primary as primary">
      <span>
        Primary: <strong>{{ primary.name || primary.phone || primary.license_plate }}</strong>
        <span *ngIf="primary.name && primary.phone"> · {{ primary.phone }}</span>
      </span>
    </div>

    <ul class="member-cards">
      <li
        class="member-card"
        *ngFor="let row of rows; trackBy: trackByRow"
        [attr.data-testid]="'family-plan-row-' + row.key"
      >
        <div class="member-card__head">
          <h4 class="member-card__title">
            {{ row.packageName }}
            <span class="family-tag" *ngIf="row.tags.isPrimary">{{ primaryLabel }}</span>
          </h4>
          <app-subscription-status-tag [status]="row.statusKey" />
        </div>

        <dl class="member-card__group" *ngFor="let group of row.fieldGroups">
          <div class="member-card__field" *ngFor="let field of group">
            <dt>{{ field.label }}</dt>
            <dd>
              <span class="plate" *ngIf="field.chip; else plain">{{ field.value }}</span>
              <ng-template #plain>{{ field.value }}</ng-template>
            </dd>
          </div>
        </dl>

        <div class="member-card__foot">
          <!-- CWS-1905: Remove member is hidden from the menu; the flow stays wired. -->
          <app-manage-subscription-menu
            label="Manage Membership"
            [showEditDetails]="true"
            [showPaymentMethod]="canUpdatePaymentMethod(row)"
            [showMoveToOwnNumber]="canMove(row)"
            [showRemoveMember]="false"
            [showUpdate]="canChangePlan(row)"
            [showCancel]="canCancel(row)"
            (update)="changePlan(row)"
            (cancelMembership)="cancelMembership(row)"
            (editDetails)="editDetails(row)"
            (moveToOwnNumber)="moveToOwnNumber(row)"
            (removeMember)="removeMember(row)"
            (paymentMethod)="openPaymentMethod(row)"
          />
          <button
            type="button"
            class="history-toggle"
            [attr.aria-expanded]="isHistoryOpen(row)"
            [attr.aria-controls]="'fp-history-' + row.key"
            (click)="toggleHistory(row)"
          >
            <img
              src="assets/images/customer/chevron-right.svg"
              alt=""
              class="history-chevron"
              [class.open]="isHistoryOpen(row)"
            />
            {{ isHistoryOpen(row) ? 'Hide history' : 'History' }}
          </button>
        </div>

        <section
          class="member-edit"
          *ngIf="editFlow.isOpen(row.key) && editFlow.model as model"
          data-testid="family-member-edit"
        >
          <h4 class="member-edit__title">Edit Family Member</h4>
          <app-family-member-form
            idPrefix="family-edit"
            nameMode="full"
            packageMode="readonly"
            [discountMode]="editFlow.discounts.length ? 'readonly' : 'hidden'"
            [model]="model"
            [errors]="editFlow.errors"
            [states]="states"
            [packages]="editFlow.packages"
            [discounts]="editFlow.discounts"
            [price]="editFlow.price"
            [showListPrice]="false"
            [contactLocked]="editFlow.contactLocked"
            [disabled]="editFlow.busy"
          />
          <p class="member-edit__note" *ngIf="editFlow.contactLocked">
            This plate has no phone of its own, so its name and phone are the primary's.
          </p>
          <p class="member-edit__error" role="alert" *ngIf="editFlow.error">
            {{ editFlow.error }}
          </p>
          <div class="member-edit__actions">
            <button type="button" class="link-btn" (click)="editFlow.close()">Cancel</button>
            <button
              type="button"
              class="outline-btn"
              data-testid="family-member-edit-save"
              [disabled]="editFlow.busy"
              (click)="editFlow.save()"
            >
              Save
            </button>
          </div>
        </section>

        <ol class="history-list" [id]="'fp-history-' + row.key" *ngIf="isHistoryOpen(row)">
          <li *ngFor="let entry of row.history">
            <span class="history-time">{{ entry.date | date: 'MMM d, y, h:mm a' }}</span>
            <span class="history-text">
              {{ entry.activity }}
              <span *ngIf="entry.package_name"> · {{ entry.package_name }}</span>
              <span *ngIf="entry.actor"> · {{ entry.actor }}</span>
            </span>
          </li>
          <li *ngIf="!row.history.length">
            <span class="history-text">No history yet.</span>
          </li>
        </ol>
      </li>
    </ul>

    <div class="add-footer" *ngIf="showAdd">
      <button
        type="button"
        class="add-btn"
        data-testid="family-plan-add-vehicle"
        (click)="addVehicle()"
      >
        <span aria-hidden="true">+</span> Add Family Member
      </button>
    </div>
  </section>
</div>

<app-family-members-modal [flow]="membersFlow" />
<app-family-remove-modal [flow]="removeFlow" />
<app-family-move-modal [flow]="moveFlow" />

<app-cancel-refund-panel
  *ngIf="cancelTarget as target"
  [isOpen]="true"
  [subscriptionId]="target.subscriptionId"
  [locationId]="target.locationId"
  intent="cancel"
  [customerName]="target.customerName"
  (closed)="closeCancel()"
  (done)="onCancelDone($event)"
/>

@if (paymentSubject; as subject) {
  <app-payment-method-modal
    [subject]="subject"
    (updated)="onPaymentMethodUpdated($event)"
    (closed)="closePaymentMethod()"
  />
}
